import { userFacingError } from "./userFacingError";

const FOREIGN_KEY_VIOLATION = "23503";
const UNIQUE_VIOLATION = "23505";
const CHECK_VIOLATION = "23514";
const LOCK_NOT_AVAILABLE = "55P03";
// The enforce_*_limit triggers in services/db/constructs/resourceLimits.ts raise
// under this name shape with a message written for the person who hit the limit.
const RESOURCE_LIMIT_CONSTRAINT = /^stack_.+_limit$/;

function extractPgError(
  err: unknown
): { code?: unknown; constraint_name?: unknown; message: string } | null {
  const candidate =
    err instanceof Error && "cause" in err && err.cause instanceof Error
      ? err.cause
      : err;
  if (!(candidate instanceof Error) || !("code" in candidate)) return null;
  return candidate as {
    code?: unknown;
    constraint_name?: unknown;
    message: string;
  };
}

function matches(
  err: unknown,
  sqlState: string,
  constraintName?: string
): boolean {
  const pg = extractPgError(err);
  if (!pg || pg.code !== sqlState) return false;
  if (constraintName === undefined) return true;
  return pg.constraint_name === constraintName;
}

export function isForeignKeyViolation(
  err: unknown,
  constraintName?: string
): boolean {
  return matches(err, FOREIGN_KEY_VIOLATION, constraintName);
}

export function isUniqueConstraintViolation(
  err: unknown,
  constraintName?: string
): boolean {
  return matches(err, UNIQUE_VIOLATION, constraintName);
}

export function isLockTimeout(err: unknown): boolean {
  for (let cause = err; cause instanceof Error; cause = cause.cause) {
    if ("code" in cause && cause.code === LOCK_NOT_AVAILABLE) return true;
  }
  return false;
}

export function mapResourceLimitViolation(err: unknown): unknown {
  const pg = extractPgError(err);
  if (
    pg?.code === CHECK_VIOLATION &&
    typeof pg.constraint_name === "string" &&
    RESOURCE_LIMIT_CONSTRAINT.test(pg.constraint_name)
  ) {
    return userFacingError(pg.message);
  }
  return err;
}
